<app-loader *ngIf="isLoading"></app-loader>
<ng-container *ngIf="activeTab === 'callbacks'">
	<div class="container mt-3">
		<div class="d-flex align-items-center gap-2 mb-3">
			<button type="button" class="btn-back" (click)="goBack()" ngbTooltip="Back">
				<i class="bx bx-arrow-back"></i>
			</button>
			<h2 class="mb-0">Callbacks</h2>
		</div>

		<!-- TABLA -->
		<ngx-datatable class="material striped" [rows]="callbacks" [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50" [rowHeight]="'auto'" [scrollbarH]="true" *ngIf="callbacks.length > 0" (activate)="onCallbackRowClick($event)">
			<ngx-datatable-column name="#" prop="callback_id" [width]="50"></ngx-datatable-column>
			<ngx-datatable-column name="Company Name" prop="company_name" [width]="150"></ngx-datatable-column>
			<ngx-datatable-column name="Prospect Name" prop="prospect_name" [width]="100"></ngx-datatable-column>
			<ngx-datatable-column name="Primary Phone" prop="primary_phone" [width]="120">
				<ng-template let-row="row" ngx-datatable-cell-template>
					{{ formatPhone(row.primary_phone) }}
				</ng-template>
			</ngx-datatable-column>
			<ngx-datatable-column name="Nota" prop="dispo_notes" [width]="280"></ngx-datatable-column>
			<ngx-datatable-column name="Callback Date" prop="callback_date" [width]="100">
				<ng-template let-value="value" ngx-datatable-cell-template>
					{{ value | date : "mediumDate" }}
				</ng-template>
			</ngx-datatable-column>
			<ngx-datatable-column [flexGrow]="2" [minWidth]="10" name=" " headerClass="cell-center title-header" cellClass="actions-cell">
				<ng-template let-row="row" ngx-datatable-cell-template>
					<div class="actions-wrapper d-flex justify-content-center align-items-center">
						<button type="button" class="btn btn-danger btn-sm btn-icon me-1" ngbTooltip="Edit" (click)="openModal(callbackModal, row); $event.stopPropagation()">
							<i class="ri-edit-line"></i>
						</button>
					</div>
				</ng-template>
			</ngx-datatable-column>
		</ngx-datatable>

		<div *ngIf="callbacks.length === 0" class="mt-3">No hay callbacks.</div>

		<!-- MODAL -->
		<ng-template #callbackModal let-modal>
			<div class="modal-header">
				<h5 class="modal-title">Editar Callback</h5>
				<span *ngIf="selectedCallback"> - {{ selectedCallback.company_name }}</span>
				<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
			</div>

			<div class="modal-body">
				<div class="mb-3">
					<label for="callbackDate" class="form-label">Fecha del Callback</label>
					<input type="date" id="callbackDate" class="form-control" [(ngModel)]="callbackDate" />
				</div>
			</div>

			<div class="modal-footer d-flex justify-content-between">
				<button type="button" class="btn btn-outline-danger" (click)="deleteCallback(); modal.close()">Delete</button>
				<button type="button" class="btn btn-primary" (click)="saveCallback(); modal.close()">Save</button>
			</div>
		</ng-template>
	</div>
</ng-container>

<!--Reschedules-->
<ng-container *ngIf="activeTab === 'reschedules'">
	<div class="col-md-12 ml-auto mr-auto" style="margin-top: 20px">
		<div class="row">
			<div class="d-flex align-items-center gap-2 mb-3">
				<button type="button" class="btn-back" (click)="goBack()" ngbTooltip="Back">
					<i class="bx bx-arrow-back"></i>
				</button>
				<h2 class="mb-0">Reschedules</h2>
			</div>
		</div>
		<ngx-datatable class="material striped" [rows]="reschedules" [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50" [rowHeight]="'auto'" [scrollbarH]="true" (activate)="onActivate($event)" *ngIf="reschedules && reschedules.length > 0">
			<ngx-datatable-column name="#" prop="id" [width]="80"></ngx-datatable-column>
			<ngx-datatable-column name="Company Name" prop="company_name" [width]="180"></ngx-datatable-column>
			<ngx-datatable-column name="Prospect Name" prop="prospect_name" [width]="180"></ngx-datatable-column>
			<ngx-datatable-column name="Primary Phone" prop="primary_phone" [width]="150">
				<ng-template let-row="row" ngx-datatable-cell-template>
					{{ formatPhone(row.primary_phone) }}
				</ng-template>
			</ngx-datatable-column>
			<ngx-datatable-column name="Notes" prop="notes" [width]="300"></ngx-datatable-column>
			<ngx-datatable-column name="App Date" prop="date_generated" [width]="200">
				<ng-template let-value="value" ngx-datatable-cell-template>
					{{ value | date : "medium" }}
				</ng-template>
			</ngx-datatable-column>
		</ngx-datatable>
		<div *ngIf="allReschedules?.length === 0" class="text-center mt-3">No hay reschedules disponibles.</div>
	</div>
</ng-container>

<ng-template #editRescheduleModal let-modal>
	<!-- HEADER -->
	<div class="modal-header">
		<div>
			<h4 class="modal-title mb-0">
				{{ selectedReschedule.company_name }}
			</h4>
			<small class="text-muted"> {{ selectedReschedule.prospect_name }} · {{ formatPhone(selectedReschedule.primary_phone) }} </small>
		</div>
		<button type="button" class="btn-close" (click)="modal.dismiss()"></button>
	</div>

	<!-- ACTION BAR -->
	<!-- STICKY ACTION BAR -->
	<div class="reschedule-action-bar">
		<div class="row align-items-end">
			<div class="col-md-6">
				<label class="form-label fw-bold mb-1 d-flex align-items-center gap-2">
					New Appointment Date
				</label>
				<input  type="datetime-local" class="form-control form-control-lg" [(ngModel)]="selectedReschedule.date_generated" />
			</div>
		</div>
	</div>

	<!-- BODY -->
	<div class="modal-body">
		<!-- BASIC INFO -->
		<div class="card mb-3">
			<div class="card-header fw-bold">Lead Information</div>
			<div class="card-body">
				<div class="row g-3">
					<div class="col-md-4">
						<label class="text-muted small">Email</label>
						<div>{{ selectedReschedule.email || "—" }}</div>
					</div>
					<div class="col-md-4">
						<label class="text-muted small">City / State</label>
						<div>{{ selectedReschedule.city }}, {{ selectedReschedule.state }}</div>
					</div>
					<div class="col-md-4">
						<label class="text-muted small">Website</label>
						<div>{{ selectedReschedule.website_url || "—" }}</div>
					</div>

					<div class="col-md-4">
						<label class="text-muted small">EIN</label>
						<div>{{ selectedReschedule.EIN || "—" }}</div>
					</div>
					<div class="col-md-4">
						<label class="text-muted small">Business Code</label>
						<div>{{ selectedReschedule.business_code }}</div>
					</div>
					<div class="col-md-4">
						<label class="text-muted small">Employee Size</label>
						<div>{{ selectedReschedule.employee_size }}</div>
					</div>
				</div>
			</div>
		</div>

		<!-- BUSINESS DETAILS -->
		<div class="card mb-3">
			<div class="card-header fw-bold">Business Details</div>
			<div class="card-body">
				<div class="row g-3">
					<div class="col-md-4">
						<label class="text-muted small">Annual Revenue</label>
						<div>{{ selectedReschedule.annual_revenue || "—" }}</div>
					</div>
					<div class="col-md-4">
						<label class="text-muted small">Plan Assets</label>
						<div>{{ selectedReschedule.plan_assets || "—" }}</div>
					</div>
					<div class="col-md-4">
						<label class="text-muted small">Participants</label>
						<div>{{ selectedReschedule.plan_participants || "—" }}</div>
					</div>

					<div class="col-md-4">
						<label class="text-muted small">Renewal</label>
						<div>
							{{ selectedReschedule.renewal_month_1 }}/{{ selectedReschedule.renewal_year_1 }}
							–
							{{ selectedReschedule.renewal_month_2 }}/{{ selectedReschedule.renewal_year_2 }}
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- NOTES -->
		<div class="card mb-3">
			<div class="card-header fw-bold">Notes</div>
			<div class="card-body">
				<p class="mb-1">
					<strong>Lead Notes:</strong><br />
					{{ selectedReschedule.notes || "No notes" }}
				</p>

				<p class="mb-0">
					<strong>Client Notes:</strong><br />
					{{ selectedReschedule.client_notes || "No client notes" }}
				</p>
			</div>
		</div>
	</div>

	<!-- FOOTER -->
	<div class="modal-footer">
		<button class="btn btn-outline-secondary" (click)="modal.dismiss()">Cancel</button>
		<button class="btn btn-primary" (click)="saveReschedule(modal)">Save Changes</button>
	</div>
</ng-template>
